
const Osamwonyi = () => {

  return (
    <div className="w-full min-h-screen bg-white">
      <div className="relative bg-[#14532d] text-white py-8 md:py-10 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight uppercase tracking-tight">
          Osamwonyi Uhunmwangho
          </h2>
        </div>
      </div>
      <div className="max-w-5xl mx-auto px-4 py-8 font-sans text-gray-800">

       
        <section>
          <div className="max-w-6xl mx-auto p-8 bg-white font-sans text-gray-700">
            <div className="flex flex-col md:flex-row gap-12">

              {/* Left Side: Image */}
              <div className="md:w-1/3">
                <div className="sticky top-24">
                  <div className="relative group">
                    <div className="absolute -inset-1 bg-gradient-to-r from-green-700 to-yellow-400 rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>
                    <img
                      src="/images/osamwonyi.jpeg"
                      alt="Kings C. Akuma"
                      className="relative w-full h-auto object-cover rounded-2xl shadow-2xl border-4 border-white"
                    />
                  </div>
                </div>
              </div>

              {/* Right Side: Content */}
              <div className="md:w-2/3">
                {/* Name and Title */}
                <header className="mb-12">
                  <h1 className="text-4xl font-black text-black mb-6 uppercase tracking-tight">PROFILE</h1>
                  <div className="text-lg leading-relaxed space-y-6 text-gray-600 font-medium">
                    <p>
                    Osamwonyi “Uyi” Uhunmwangho is a seasoned legal practitioner, corporate governance professional, and dispute resolution expert with extensive experience spanning banking, financial services, risk management, and complex commercial litigation across multiple African jurisdictions.
                    </p>
                    <p>
                    He currently serves as <b>Head, Legal - Litigation, Standard Bank Africa Regions & Offshore, </b>  where he provides strategic oversight of litigation and dispute resolution across Standard Bank's operations in Africa, as well as its offshore jurisdictions of Jersey and the Isle of Man. He also serves as <b> Head of the Dispute Resolution Unit at Stanbic IBTC Holdings PLC, Nigeria</b> , one of the country's leading financial services groups.

  With a distinguished career in legal practice and financial services, Uyi has developed deep expertise in corporate governance, regulatory compliance, legal risk management, dispute resolution, and stakeholder engagement. He has successfully led and managed high-value and complex commercial disputes, providing strategic guidance to executive leadership teams and boards on litigation, reputational risk, and governance matters.

                    </p>
                    <p>
                    Uyi is widely recognised as a thought leader in the legal and financial sectors and has served as a resource person and speaker at several notable professional forums, including the Annual Seminar on Banking and Allied Matters for Judges organised by the Chartered Institute of Bankers of Nigeria (CIBN), the Nigerian Bar Association's Section on Legal Practice Conference, and specialised professional development programmes for legal and dispute resolution practitioners.
                    </p>
                    <p>

                    He holds Master's degrees in <b> Law</b> , and <b> Industrial Relations and Personnel Management</b> , reflecting his multidisciplinary understanding of governance, organisational leadership, labour relations, and business strategy. He is an Associate of the <b> Chartered Institute of Arbitrators (UK), Nigeria Branch</b> , a member of the <b> Chartered Insurance Institute of Nigeria</b> , and an alumnus of the <b>Risk Gamechangers Academy </b>  of the University of Cape Town Graduate School of Business.                    </p>
                    <p>

                    Uyi brings to the Board a unique combination of legal expertise, strategic insight, governance experience, risk management capability, and a commitment to sustainable organisational growth. His contributions are informed by a strong appreciation of the regulatory environment, stakeholder expectations, and the importance of sound corporate governance in delivering long-term value.                    </p>
                    <p>
                        
                    In addition to his professional engagements, he is an author, mentor, and advocate for leadership development and personal growth. His published works, including Love in 4D and The Betterist, reflect his passion for excellence, resilience, and human development.                    </p>
                  </div>
                </header>  
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Osamwonyi;